import { ProductGtmEvents } from '@/gtm/product/product-gtm-events';

export class ProductRecommendationGtmEvents extends ProductGtmEvents {
  scrollProducts() {
    return this.gtmEvent({
      eventAction: 'Карточка_Рекомендации_Скрол',
    });
  }

  openQuickView({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Рекомендации_БП',
      eventLabel: productCode,
    });
  }

  clickProduct({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Рекомендации_Клик',
      eventLabel: productCode,
    });
  }

  chooseSize({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Рекомендации_Размер',
      eventLabel: productCode,
    });
  }

  chooseColor({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Рекомендации_Цвет',
      eventLabel: productCode,
    });
  }

  addToFavorite({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Рекомендации_ДобавитьВИзбранное',
      eventLabel: productCode,
    });
  }

  removeFromFavorite({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Рекомендации_УдалитьИзИзбранного',
      eventLabel: productCode,
    });
  }

  toggleFavorite({ value, productCode }) {
    return value
      ? this.addToFavorite({ productCode })
      : this.removeFromFavorite({ productCode });
  }
}
